import React from "react";
import Container from "../container";
import { getAvatar, getUserData } from "@icarius-app/selectors";
import { useSelector } from "react-redux";
import { getTasks } from "@icarius-pages/myDesktop/selectors";
import ProgressItem from "./progress/progressItem";
import { getLocalizedString } from "@icarius-localization/strings";

const Tasks = ({ small }) => {
    const avatar = useSelector(getAvatar);
    const { name } = useSelector(getUserData);
    const tasks = useSelector(getTasks);

    if (!tasks?.data?.length) return null;

    return (
        <Container title={getLocalizedString("myNotes")}>
            <ProgressItem
                name={name}
                percentage={tasks?.progress || 0}
                avatar={avatar}
                data={tasks?.data || []}
                small={small}
            />
        </Container>
    );
};

export default Tasks;
